import { Card } from "primereact/card";
import { useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Badge } from "primereact/badge";
import {
  useGetOrdersByClentCodeQuery,
  useUpsertOrderMutation,
} from "../store/api/orderAPI";
import { useGetTypesQuery } from "../store/api/directory/typeApi";
import { useLocation } from "react-router-dom";
import {
  useChangeUserTypeMutation,
  useSendUserWhatsappMutation,
} from "../store/api/userAPI";
import { t } from "i18next";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import PresortDemo from "../components/table/DataTable";
import { orderColumnDetail } from "../metadata/order";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { Sidebar } from "primereact/sidebar";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useGetRecipientsQuery } from "../store/api/directory/regionApi";

const OrderDashboard = () => {
  const location = useLocation();
  const toast = useRef(null);
  const [visibleLeft, setVisibleLeft] = useState({
    visible: false,
    data: null,
  });
  const [formData, setFormData] = useState({});
  const { clientCode, user_type, first_name, last_name, client_code } = location.state;
  console.log(location.state);
  const { data: userStatuses } = useGetTypesQuery();
  const orderColumnTr = useTranslatedColumns(orderColumnDetail);
  const [sendMessageWhatsapp] = useSendUserWhatsappMutation();
  const { data: recipients = [], isLoading } =
    useGetRecipientsQuery(clientCode);
  const [changeUserType] = useChangeUserTypeMutation();
  const [messageDialogVisible, setMessageDialogVisible] = useState(false);
  const selectedProducts = [location.state];
  const [messageText, setMessageText] = useState("");
  const [createOrUpdateOrder] = useUpsertOrderMutation();
  const handleSendMessage = async () => {
    if (!messageText.trim()) return;

    try {
      await sendMessageWhatsapp({
        users: selectedProducts,
        message: messageText,
      }).unwrap(); // <- ВАЖНО

      toast.current.show({
        severity: "success",
        summary: "Успешно",
        detail: "Сообщение отправлено",
      });

      setMessageDialogVisible(false);
      setMessageText("");
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Ошибка",
        detail: "Не удалось отправить сообщение",
      });
    }
  };

  let {
    data: orders = {
      result: [],
      resultCountByStatus: [],
    },
  } = useGetOrdersByClentCodeQuery(
    {
      clientCode: clientCode,
    },
    {
      skip: !clientCode,
    }
  );
  const [userStatus, setUserStatus] = useState(user_type);
  function toggleSidebar(bool, data) {
    setFormData(data);
    setVisibleLeft((state) => {
      return {
        visible: bool,
        data: data,
      };
    });
  }

  const onBlur = (e, attr, value) => {
    setFormData((state) => {
      return {
        ...state,
        [attr]: value,
      };
    });
  };

  return (
    <>
      <Dialog
        header="Введите сообщение"
        visible={messageDialogVisible}
        onHide={() => setMessageDialogVisible(false)}
        modal
        blockScroll
        appendTo={document.body} // ← ВЫНОСИМ В BODY
        style={{ width: "100%", maxWidth: "600px" }}
      >
        <div className="flex flex-column gap-3">
          <InputTextarea
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            rows={5}
            autoResize
            className="w-full"
          />

          <div className="flex justify-content-end gap-2 mt-3">
            <Button
              label="Отправить"
              severity="success"
              onClick={handleSendMessage}
            />
            <Button
              label="Отмена"
              severity="secondary"
              outlined
              onClick={() => setMessageDialogVisible(false)}
            />
          </div>
        </div>
      </Dialog>
      <Toast ref={toast} />

      <div className="dashboard-container">
        <div className="user-detail-grid">
          <PresortDemo
            data={orders.result}
            column={orderColumnTr}
            toggleSidebar={toggleSidebar}
          // scrollHeight="calc(100vh - 80px)"
          />

          <div className="stats-section">
            <Card className="stats-card">
              <div className="stats-card_content">
                <h3 style={{ textAlign: "center" }}>{first_name + " " + last_name + " " + client_code}</h3>
                <div style={{ padding: "0 12px", width: "100%" }}>
                  <Dropdown
                    value={userStatus}
                    options={userStatuses}
                    optionLabel="type_name"
                    optionValue="guid"
                    onChange={(e) => {
                      changeUserType({
                        client_guid: clientCode,
                        user_type: e.target.value,
                      });
                      setUserStatus(e.target.value);
                    }}
                    placeholder="Выбрать уровень пользователя"
                    className="status-dropdown"
                  />
                </div>
                <p className="current-status">
                  Заказы: <strong>{userStatus?.label}</strong>
                </p>
                <ul className="stat-list">
                  {orders.resultCountByStatus.map((el) => {
                    return (
                      <li>
                        {el.status_name} <Badge value={el.countOrder} />
                      </li>
                    );
                  })}
                </ul>
                <p className="current-status">Получатели:</p>
                <ul className="stat-list">
                  {recipients.map((el) => {
                    return (
                      <li>
                        Имя: {el.name} <br />
                        ИНН: {el.ppt_inn} <br />
                        Адрес: {el.address}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Card>
          </div>
        </div>
      </div>
      <Sidebar
        visible={visibleLeft.visible}
        position="right"
        onHide={() => {
          toggleSidebar(false);
        }}
        style={{ width: "50vw" }}
      >
        <div className="user-sidebar">
          <div className="user-sidebar-edit">
            {orderColumnTr
              .filter((i) => i.editor)
              .map((el) => {
                return (
                  <div>
                    <Editor {...el} onBlur={onBlur} data={formData} />
                  </div>
                );
              })}
            <div></div>
            <MyButton
              label={t("save")}
              onClick={async () => {
                await createOrUpdateOrder(formData);
                // await console.log(formData);
                // toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
                // toggleSidebar(false)
              }}
            />
          </div>
        </div>
      </Sidebar>
    </>
  );
};

export default OrderDashboard;
